import React from 'react';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import LinkText from 'components/LinkText';
import Money from 'components/Money';
import ExternalLink from 'components/ExternalLink';

import xeroIcon from './assets/xero-logo.svg';
import goCardlessIcon from './assets/go-cardless-logo.svg';
import launchIcon from './assets/launch-47.svg';

import './styles.css';

const TransactionsTable = ({payment, onInvoiceClick}) => {
  const {transaction} = payment;
  const {invoice} = payment;
  return (
    <div className="TransactionsTable">
      <Table>
        <Table.Header>
          <Table.HeaderItem heading="Invoice NO" className="invoiceNumber" />
          <Table.HeaderItem heading="Invoice Date" className="invoiceDate" />
          <Table.HeaderItem heading="Due date" className="dueDate" />
          <Table.HeaderItem heading="Batch Number" className="batchNumber" />
          <Table.HeaderItem
            heading="Credit card number"
            className="creditCardNumber"
          />
          <Table.HeaderItem heading="Description" className="description" />
          <Table.HeaderItem
            heading={<img src={xeroIcon} alt="Xero Transaction" />}
            className="xeroTransaction"
          />
          <Table.HeaderItem
            heading={<img src={goCardlessIcon} alt="GoCardless Transaction" />}
            className="gcTransaction"
          />
          <Table.HeaderItem heading="Invoice total" className="invoiceTotal" />
          <Table.HeaderItem
            heading="Amount applied"
            className="amountApplied"
          />
        </Table.Header>
        <Table.Body>
          <Table.Row>
            <Table.Cell>
              <LinkText onClick={() => onInvoiceClick(invoice)}>
                {invoice.number}
              </LinkText>
            </Table.Cell>
            <Table.Cell>{formatDate(invoice.dateIssued)}</Table.Cell>
            <Table.Cell>{formatDate(invoice.dueDate)}</Table.Cell>
            <Table.Cell>{payment.batchNumber}</Table.Cell>
            <Table.Cell>{payment.creditCardNumber}</Table.Cell>
            <Table.Cell>{invoice.description}</Table.Cell>
            <Table.Cell>
              {payment.xeroId &&
                payment.xeroLink && (
                  <ExternalLink href={payment.xeroLink} targetBlank>
                    <img src={launchIcon} alt="Launch Icon" />
                  </ExternalLink>
                )}
            </Table.Cell>
            <Table.Cell>
              {payment.gocardlessPaymentId &&
                payment.gocardlessPaymentLink && (
                  <ExternalLink
                    href={payment.gocardlessPaymentLink}
                    targetBlank>
                    <img src={launchIcon} alt="Launch Icon" />
                  </ExternalLink>
                )}
            </Table.Cell>
            <Table.Cell>
              <Money amount={invoice.totalIncludingTax} />
            </Table.Cell>
            <Table.Cell>
              <Money amount={transaction.amount} />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </div>
  );
};

export default TransactionsTable;
